"use strict";
exports.__esModule = true;
exports.PopupLoader = void 0;
var PopupBase_1 = require("./PopupBase");
var PopupLoader = /** @class */ (function () {
    function PopupLoader() {
        this.popups = [];
        this.types = {};
    }
    PopupLoader.prototype.get = function (name) {
        if (!this.named_popups)
            throw new Error("Popups not yet loaded");
        return this.named_popups[name];
    };
    PopupLoader.prototype.register_type = function (type, constructor) {
        this.types[type] = constructor;
    };
    PopupLoader.prototype.load = function () {
        var named_popups = {};
        var popup_elements = document.getElementsByClassName('yd-ph-popup');
        this.popups = [];
        for (var i = 0; i < popup_elements.length; ++i) {
            var popup_element = popup_elements.item(i);
            var popup = this.create_popup(popup_element);
            this.popups.push(popup);
            var name_1 = popup.get_name();
            if (name_1) {
                named_popups[name_1] = popup;
            }
        }
        this.named_popups = named_popups;
        return this.popups;
    };
    PopupLoader.prototype.create_popup = function (element) {
        var constructor = this.deterimine_popup_class(element);
        return new constructor(element);
    };
    PopupLoader.prototype.deterimine_popup_class = function (element) {
        var type = element.getAttribute('data-popup-type');
        if (!type)
            return PopupBase_1.PopupBase;
        if (type in this.types)
            return this.types[type];
        return PopupBase_1.PopupBase;
    };
    return PopupLoader;
}());
exports.PopupLoader = PopupLoader;
